import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import PaymentContext from 'Components/Payment/payment-context';

const folder = 'https://cdn.fanatical.com/production/product/payment-methods-cart/svg';

const getIcon = (type, name) => {
  let img;
  switch (type) {
    case 'visa':
      img = <img key={type} loading="lazy" src={`${folder}/visa_2021.svg`} alt="VISA" className="visa" height="100%" width="100%" />;
      break;
    case 'mc':
      img = <img key={type} loading="lazy" src={`${folder}/mastercard.svg`} alt="Master Card" className="mastercard" height="100%" width="100%" />;
      break;
    case 'amex':
      img = <img key={type} loading="lazy" src={`${folder}/american-express.svg`} alt="American Express" className="amex" height="100%" width="100%" />;
      break;
    case 'maestro':
      img = <img key={type} loading="lazy" src={`${folder}/maestro.svg`} alt="Maestro" className="maestro" height="100%" width="100%" />;
      break;
    case 'discover':
      img = <img key={type} loading="lazy" src={`${folder}/discover.svg`} alt="Discover" className="discover" height="100%" width="100%" />;
      break;
    case 'diners':
      img = <img key={type} loading="lazy" src={`${folder}/diners.svg`} alt="Diners Club" className="diners" height="100%" width="100%" />;
      break;
    case 'jcb':
      img = <img key={type} loading="lazy" src={`${folder}/jcb.svg`} alt="JCB" className="jcb" height="100%" width="100%" />;
      break;
    case 'cartebancaire':
      img = <img key={type} loading="lazy" src={`${folder}/cartebancaire.svg`} alt="Cartes Bancaires" className="cartebancaire" height="100%" width="100%" />;
      break;
    case 'paypal':
      img = <img key={type} loading="lazy" src={`${folder}/paypal.svg`} alt={name} className="paypal" height="100%" width="100%" />;
      break;
    case 'alipay':
      img = <img key={type} loading="lazy" src={`${folder}/alipay.svg`} alt={name} className="alipay" height="100%" width="100%" />;
      break;
    case 'applepay':
      img = <img key={type} loading="lazy" src={`${folder}/applepay.svg`} alt={name} className="applepay" height="100%" width="100%" />;
      break;
    case 'paywithgoogle':
      img = <img key={type} loading="lazy" src={`${folder}/googlepay-mark.svg`} alt={name} className="googlepay" height="100%" width="100%" />;
      break;
    case 'klarna':
      img = <img key={type} loading="lazy" src={`${folder}/klarna.svg`} alt={name} className="klarna" height="100%" width="100%" />;
      break;
    case 'directEbanking':
      img = <img key={type} loading="lazy" src={`${folder}/sofort.svg`} alt={name} className="alipay" height="100%" width="100%" />;
      break;
    case 'unionpay':
    case 'cup':
      img = <img key={type} loading="lazy" src={`${folder}/unionpay.svg`} alt={name} className="expresspay" height="100%" width="100%" />;
      break;
    case 'qiwi':
      img = <img key={type} loading="lazy" src={`${folder}/qiwi.svg`} alt={name} className="qiwi" height="100%" width="100%" />;
      break;
    case 'ideal':
      img = <img key={type} loading="lazy" src={`${folder}/ideal.svg`} alt={name} className="ideal" height="100%" width="100%" />;
      break;
    case 'wechatpayQR':
      img = <img key={type} loading="lazy" src={`${folder}/wechatpayQR.svg`} alt={name} className="wechatpayQR" height="100%" width="100%" />;
      break;
    default:
      img = null;
  }

  if (!img) return false;

  return (
    <div key={type} className={`payment-image ${type}`}>
      {img}
    </div>
  );
};

export default function PaymentIcon({ name, type, brands, isApplePay }) {
  const { lastUsed } = useContext(PaymentContext);

  if (!type) {
    return false;
  }

  if (brands && brands.length && type !== 'applepay') {
    if (lastUsed) {
      brands.sort((a, b) => {
        if (b === lastUsed) {
          return 1;
        }
        if (a === lastUsed) {
          return -1;
        }
        return 0;
      });
    }

    return (
      <div className="payment-image-container">
        {getIcon(type)}
        {brands.map(brand => getIcon(brand))}
      </div>
    );
  }

  const icon = getIcon(type, name);

  if (!icon) {
    return false;
  }

  return (
    <div className="payment-image-container">
      {icon}
      {isApplePay && getIcon('applepay')}
    </div>
  );
}

PaymentIcon.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  brands: PropTypes.arrayOf(PropTypes.string),
  isApplePay: PropTypes.bool,
};

PaymentIcon.defaultProps = {
  brands: null,
  isApplePay: false,
};
